interface CurrencyFormatOptions {
  locale?: string;
  currency: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatCurrency(
  amount: number | undefined | null,
  options: CurrencyFormatOptions,
): string {
  if (amount == null) return 'N/A';
  return new Intl.NumberFormat(options.locale || 'en', {
    style: 'currency',
    currency: options.currency,
    minimumFractionDigits: options.minimumFractionDigits ?? 2,
    maximumFractionDigits: options.maximumFractionDigits ?? 2,
  }).format(amount);
}
